import type * as hast from 'hast';
import { is } from 'unist-util-is';
import { visit } from 'unist-util-visit';

import { isEmpty, isLinkElement } from './utils';

/**
 * Remove any empty anchor elements from a hast, transferring their id to the parent element.
 */
export function stripEmptyAnchor() {
    return (tree) => {
        visit(
            tree,
            isLinkElement,
            (node: hast.Element, index: number, parent?: hast.Element | hast.Root) => {
                if (is(node, isEmpty) && parent) {
                    if (parent.type === 'element') {
                        // Empty a tag, the id needs to be put on the following element.
                        parent.properties = {
                            ...parent.properties,
                            // `name` is an alternative to `id`
                            // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-name
                            id: node.properties?.id || node.properties?.name,
                        };
                    }

                    // Trim the previous text node if any
                    const previousNode = parent.children[index - 1];
                    if (previousNode?.type === 'text') {
                        previousNode.value = previousNode.value.trimRight();
                    }

                    parent.children.splice(index, 1);
                }
            }
        );
    };
}
